/* ===========================================================================
   VD Delivery Estimate
   - Dubai & Abu Dhabi: SAME-DAY delivery.
   - All other emirates: NEXT-DAY delivery.
   Before the shopper picks an emirate, it shows a same-day availability message
   plus a clear prompt to choose their emirate (no auto-detect, so it never shows
   the wrong city). After they pick, it shows their exact dated estimate.
   Localized via window.VD_DEL_I18N (English + Arabic). Dates use Asia/Dubai (GST).
   =========================================================================== */
(function () {
  "use strict";

  var SAME_DAY_EMIRATES = ["Dubai", "Abu Dhabi"];
  var ALL_EMIRATES = [
    "Dubai", "Abu Dhabi", "Sharjah", "Ajman",
    "Umm Al Quwain", "Ras Al Khaimah", "Fujairah"
  ];
  var STORE_KEY = "vd_emirate";

  var currentEmirate = null;

  var I = (typeof window !== "undefined" && window.VD_DEL_I18N) ? window.VD_DEL_I18N : {};
  function t(key, fallback) { return (I && I[key]) ? I[key] : fallback; }
  function emName(em) { return (I.emirates && I.emirates[em]) ? I.emirates[em] : em; }
  function pill(txt) { return "<span class='vd-del__pill'>" + txt + "</span>"; }

  // ----- Time helpers (Asia/Dubai) -----------------------------------------
  function uaeParts() {
    var f = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Dubai", year: "numeric", month: "2-digit", day: "2-digit"
    });
    var o = {};
    f.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, mo: +o.month, d: +o.day };
  }
  function dateAddUTC(p, n) { return new Date(Date.UTC(p.y, p.mo - 1, p.d + n)); }
  function fmtDate(dt) {
    var loc = (I.lang === "ar") ? "ar" : "en-GB";
    try {
      return new Intl.DateTimeFormat(loc, {
        timeZone: "UTC", weekday: "short", day: "numeric", month: "short"
      }).format(dt);
    } catch (e) {
      return new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC", weekday: "short", day: "numeric", month: "short"
      }).format(dt);
    }
  }
  function isSameDay(em) { return SAME_DAY_EMIRATES.indexOf(em) > -1; }

  function compute(em) {
    var p = uaeParts();
    var sd = isSameDay(em);
    return { emirate: em, sameDay: sd, date: fmtDate(dateAddUTC(p, sd ? 0 : 1)) };
  }

  // ----- Rendering ----------------------------------------------------------
  function render(node) {
    var compact = node.getAttribute("data-vd-compact") === "1";
    var headline = node.querySelector("[data-vd-headline]");
    var sub = node.querySelector("[data-vd-sub]");
    if (!headline || !sub) return;

    // Prompt state: no emirate chosen yet.
    if (!currentEmirate) {
      node.classList.remove("vd-del--nextday");
      node.classList.add("vd-del--sameday", "vd-del--prompt");
      headline.innerHTML = t("promptHeadline", "Same-day delivery in Dubai & Abu Dhabi");
      if (compact) {
        sub.innerHTML = t("promptSubCompact", "Fast next-day delivery to all other emirates");
      } else {
        sub.innerHTML = "<span class='vd-del__cta'>" +
          t("promptSub", "Select your emirate to see your delivery date") +
          " <span class='vd-del__arrow' aria-hidden='true'>›</span></span>";
      }
      return;
    }

    node.classList.remove("vd-del--prompt");
    var r = compute(currentEmirate);
    var nm = emName(currentEmirate);

    node.classList.remove("vd-del--sameday", "vd-del--nextday");
    node.classList.add(r.sameDay ? "vd-del--sameday" : "vd-del--nextday");

    if (r.sameDay) {
      var hl = t("sameDayHeadline", "Same-day delivery to {em}").replace("{em}", nm);
      headline.innerHTML = (compact ? "🟢 " : "") + hl + (compact ? "" : pill(t("pillToday", "Today")));
      sub.innerHTML = compact
        ? t("compactToday", "Get it <strong>today</strong>")
        : t("estToday", "Estimated delivery: <strong>today, {date}</strong>").replace("{date}", r.date);
    } else {
      var hl2 = t("nextDayHeadline", "Fast next-day delivery to {em}").replace("{em}", nm);
      headline.innerHTML = hl2 + (compact ? "" : pill(t("pillTomorrow", "Tomorrow")));
      sub.innerHTML = compact
        ? t("compactTomorrow", "Get it <strong>tomorrow</strong>")
        : t("estTomorrow", "Order today, get it <strong>tomorrow, {date}</strong> — fast, tracked delivery.").replace("{date}", r.date);
    }
  }

  function renderAll() {
    document.querySelectorAll("[data-vd-delivery]").forEach(render);
  }

  // ----- Selection ----------------------------------------------------------
  function setEmirate(em, manual) {
    if (ALL_EMIRATES.indexOf(em) < 0) return;
    currentEmirate = em;
    if (manual) { try { localStorage.setItem(STORE_KEY, em); } catch (e) {} }
    syncSelects();
    renderAll();
  }
  function syncSelects() {
    document.querySelectorAll("[data-vd-emirate]").forEach(function (sel) {
      var want = currentEmirate || "";
      if (sel.value !== want) sel.value = want;
    });
  }

  // ----- Wiring per widget --------------------------------------------------
  function setupNode(node) {
    if (node.getAttribute("data-vd-ready") === "1") return;
    node.setAttribute("data-vd-ready", "1");

    var sel = node.querySelector("[data-vd-emirate]");
    if (sel && !sel.options.length) {
      var ph = document.createElement("option");
      ph.value = "";
      ph.textContent = t("selectPlaceholder", "Select your emirate");
      sel.appendChild(ph);
      ALL_EMIRATES.forEach(function (e) {
        var opt = document.createElement("option");
        opt.value = e;                 // canonical English value (used for logic)
        opt.textContent = emName(e);   // localized label shown to the customer
        sel.appendChild(opt);
      });
      sel.value = currentEmirate || "";
      sel.addEventListener("change", function () {
        if (sel.value) setEmirate(sel.value, true);
      });
    }

    var toggle = node.querySelector("[data-vd-toggle]");
    var details = node.querySelector("[data-vd-details]");
    if (toggle && details) {
      var doToggle = function () {
        var open = node.classList.toggle("is-open");
        details.hidden = !open;
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      };
      toggle.addEventListener("click", function (ev) {
        if (ev.target.closest("[data-vd-emirate]")) return;
        doToggle();
      });
      toggle.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); doToggle(); }
      });
    }
    render(node);
  }

  function scan() {
    document.querySelectorAll("[data-vd-delivery]").forEach(setupNode);
  }

  // ----- Init ---------------------------------------------------------------
  function init() {
    try { currentEmirate = localStorage.getItem(STORE_KEY) || null; } catch (e) { currentEmirate = null; }
    if (currentEmirate && ALL_EMIRATES.indexOf(currentEmirate) < 0) currentEmirate = null;

    scan();
    syncSelects();
    renderAll();

    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { scan(); break; }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (window.__vdDelLoaded) { scan(); return; }
  window.__vdDelLoaded = true;
  window.vdDeliveryRescan = scan;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
